export default class ClipboardCopy extends HTMLElement {

	constructor(){

		super();

	}
}
